import { SearchableCombobox, TSearchable } from '../../base/combobox'
import { useCombobox } from '@/helpers/useCombobox'
import { CustomFieldResource } from '@/types'

interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}

interface CustomFieldResourceItem {
  id: CustomFieldResource
  name: string
}

const values: CustomFieldResourceItem[] = [
  { id: CustomFieldResource.AssetType, name: 'Asset type' },
  { id: CustomFieldResource.Asset, name: 'Asset' },
  { id: CustomFieldResource.Package, name: 'Package' },
  { id: CustomFieldResource.Venue, name: 'Venue' },
]

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { items } = useCombobox<CustomFieldResourceItem>({
    pageInfo: undefined,
    querySelected: undefined,
    queryCollection: values,
    buildSearchable: item => item
  })

  return (
    <SearchableCombobox
      data={items}
      fetchMore={() => {}}
      includeBlank={false}
      invalid={invalid}
      loading={false}
      moreToFetch={false}
      refetch={() => {}}
      searchField=""
      value={items.find(d => d.id == value) || { id: value, name: value }}
      onChange={onChange}
    />
  )
}
